// extracted by mini-css-extract-plugin
export default {"wrapper":"Snackbar_wrapper__neOpJ","closeButton":"Snackbar_closeButton__5kZZ8"};